import { DirectiveBinding } from 'vue';
import { useEventListener } from '@vueuse/core';
import { checkAuthorityToast } from '@/utils/common';

/**
 * 没有权限点击提示：校验权限并执行回调(for循环中以及需要多个权限判断时建议使用checkAuthorityToast事件判断，不建议使用指令)
 * 注意：在for中使用该指令时要注意dom元素的key是否能唯一的跟click事件绑定，key尽量避免使用index！！！
 * 点击回调有参：v-authority-toast:dd="() => onClick(params)"
 * 其中dd(String)：字符串的权限常量、onClick(Function)：该DOM的点击事件、params(any)：点击事件参数
 * v-authority-toast:dd="onClick" 当这样写的时候要确保onClick事件没有接收参数，否则可能会判断错误
 */
const customClick = (binding: DirectiveBinding) => {
  return () => {
    if (!binding.arg) return;
    const authority = ((binding.arg as any) ?? '').split(',');
    const check = checkAuthorityToast(authority);
    if (check) {
      // 正常触发点击事件
      if (binding.value) {
        binding.value();
      }
    }
  };
};

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    useEventListener(el, 'click', customClick(binding));
  },
};
